module.exports = __webpack_public_path__ + "media/luxury-2026/conyers-entry-960-2541475f.jpg";